(async function changeLocalText() {
    try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json');
        const data = await response.json();
        
        const countryCode = data.country;

        const translations = {
            en: { DK: "DK delivery: 1 – 3 days", GB: "UK delivery: 2 – 5 days", EU: "EU delivery: 4 – 10 days" },
            da: { DK: "DK levering: 1 – 3 dage", GB: "UK levering: 2 – 5 dage", EU: "EU levering: 4 – 10 dage" },
            de: { DK: "DK Lieferung: 1 – 3 Tage", GB: "UK Lieferung: 2 – 5 Tage", EU: "EU Lieferung: 4 – 10 Tage" },
            fr: { DK: "Livraison DK : 1 – 3 jours", GB: "Livraison au Royaume-Uni : 2 – 5 jours", EU: "Livraison UE : 4 – 10 jours" },
        };
      
        const lang = (document.documentElement.lang || "en").toLowerCase().substring(0, 2);
        const t = translations[lang] || translations["en"]; 
        const europeCodes = ['AL','AD','AT','BY','BE','BA','BG','HR','CY','CZ','EE','FI','FR','DE','GR','HU','IS','IE','IT','LV','LI','LT','LU','MT','MD','MC','ME','NL','MK','NO','PL','PT','RO','RS','RU','SM','SK','SI','ES','SE','CH','UA','VA'];
        
        let finalShippingString = "International delivery: 1 – 2 weeks";

        if (countryCode === "DK") {
            finalShippingString = t["DK"];
        } else if (countryCode === "GB") {
            finalShippingString = t["GB"];
        } else if (europeCodes.includes(countryCode)) {
            finalShippingString = t["EU"];
        } else {
            document.querySelectorAll(".free-ship").forEach(el => el.remove());
            document.querySelectorAll(".modu-topBar__delivery").forEach(el => el.textContent = finalShippingString);
        }

        document.querySelectorAll(".psst-shipping-text").forEach(el => el.textContent = finalShippingString);

        // 2. CSS-magien til kurven (Så teksten overlever Rivets)
        const style = document.createElement('style');
        style.innerHTML = `.psst-shipping-text:empty::before { content: var(--modu-ship-text); }`;
        document.head.appendChild(style);
        document.documentElement.style.setProperty('--modu-ship-text', `"${finalShippingString}"`);

        // Partner link for US
        if (countryCode === "US") {
            document.querySelectorAll(".us-partner-link").forEach(el => el.style.display = "inline-flex");
        }

    } catch (error) {
        console.error("Kunne ikke hente geolokation fra GeoJS:", error);
    }
})();